import { makeStyles } from '@mui/styles';
import Typography from '@classify/react-core-components/Typography';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing }) => ({
    root: {
      marginBottom: spacing(3),
      listStyle: 'none',
      display: 'flex',
      alignItems: 'flex-start',
    },
    label: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
    bullet: {
      marginRight: spacing(2),
    },
  }),
  { classNamePrefix: 'CustomLi' }
);

export default function CustomLi({
  classes: customClasses = {},
  children,
  icon,
  variant = 'body',
  component = 'p',
}) {
  const classes = useStyles({ classes: customClasses });

  return (
    <li className={classes.root}>
      <Typography className={classes.label} variant={variant} component={component}>
        <span className={classes.bullet}>{icon}</span>
        {children}
      </Typography>
    </li>
  );
}
